import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'

const useDaysOfWeekCheckbox = (update: Dispatch<SetStateAction<DayOfWeekType[]>>) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const id = event.target.id
      // DayOfWeekTypeか検証する
      if (
        id !== 'sun' &&
        id !== 'mon' &&
        id !== 'tue' &&
        id !== 'wed' &&
        id !== 'thu' &&
        id !== 'fri' &&
        id !== 'sat' &&
        id !== 'hol'
      )
        return

      update((prevState) => {
        // 選択済みの値であれば削除
        if (prevState.some((state) => state === id)) {
          return prevState.filter((state) => state !== id)
        } else {
          return [...prevState, id]
        }
      })
    },
    [update]
  )
}

export default useDaysOfWeekCheckbox
